import React from 'react'
import RecordLiquidation from '../../containers/recordLiquidation'

const RecordLiquidationPage = () => {
  return <RecordLiquidation />
}

export default RecordLiquidationPage
